"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonStyled = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _ramda = require("ramda");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _palette = require("../../../styles/palette");

var _widths = require("../../../styles/widths");

var _templateObject;

var ButtonStyled = _styledComponents["default"].button(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  background-color: ", ";\n  border: ", ";\n  border-radius: ", "px;\n  color: ", ";\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: ", ";\n  line-height: 1.3;\n  margin-top: ", "px;\n  margin: ", ";\n  padding: 13px ", "px;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  &:hover {\n    background: ", ";\n  }\n\n  &:active {\n    background: ", ";\n  }\n\n  &:focus {\n    outline: none;\n  }\n"])), function (props) {
  return props.reverse ? _palette.palette.white : props.theme.colors.primary;
}, function (props) {
  return props.reverse ? "solid 1px ".concat(_palette.palette.primary) : 0;
}, _widths.widths.base, function (props) {
  return props.reverse ? _palette.palette.primary : _palette.palette.white;
}, _widths.font.medium, _widths.widths.base * 3, (0, _ramda.prop)('margin'), _widths.widths.base * 4, function (props) {
  return props.width && "\n    width: ".concat(typeof props.width === 'string' ? props.width : "".concat(props.width, "px"), ";\n  ");
}, function (props) {
  return props.height && "\n    height: ".concat(typeof props.height === 'string' ? props.height : "".concat(props.height, "px"), ";\n  ");
}, function (props) {
  return props.disabled && "\n    background-color: ".concat(_palette.palette.disabled, ";\n    pointer-events: none;\n  ");
}, function (props) {
  return props.reverse ? _palette.palette.white : _palette.palette.primaryHover;
}, function (props) {
  return props.reverse ? _palette.palette.white : _palette.palette.primaryPressed;
});

exports.ButtonStyled = ButtonStyled;
ButtonStyled.displayName = 'Button';